import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    //get all roles list
    getRolesList() {
        return api.get(`/api/v1/role`);
    },
    //assign role to user
    assignRole(data) {
        return api.put(`/api/v1/user-role`, data);
    },
}